import UserManagement from './userManagementDemo'

export {
    UserManagement
}